<template>
  <EmatPopup :menu="isMounted" @close="$emit('close')">
    <template v-slot:header>
      <span class="title">{{ productCategory.title }}</span>
    </template>
    <template v-slot:body>
      <EmatProduct
          :class="device"
          v-for="product in productCategory.products || []"
          :key="product.id"
          :product="product"
          :amount="productAmount(product)"
          @setProduct="selectProduct"
      />
    </template>
    <template v-slot:footer>
      <div class="product-modal-footer">
        <span class="text">{{ $t('ProductsBlock.select_products_first') }}</span>
        <button
            type="submit"
            class="btn-green next"
            :disabled="selectedProductsAmount === 0 && buildProductByCategoryAmount === 0"
            @click="editCart"
        >
          <span v-if="hasInitialSelectedProducts">{{ $t('ProductsBlock.edit_cart') }}</span>
          <span v-else>{{ $t('ProductsBlock.add_to_cart') }}</span>
        </button>
      </div>
    </template>
  </EmatPopup>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { cloneDeep } from 'lodash';
import EmatPopup from 'Components/Layout/Popup';
import EmatProduct from 'Components/Layout/Product';

export default {
  name: 'ProductsBlockPopup',
  components: {
    EmatPopup,
    EmatProduct,
  },
  props: {
    productCategory: {
      required: true,
      type: Object,
      validator: (value) => {
        return 'title' in value && 'products' in value && Array.isArray(value.products);
      }
    },
  },
  data() {
    return {
      isMounted: false,
      hasInitialSelectedProducts: false,
      selectedProducts: [],
    }
  },
  computed: {
    ...mapGetters({
      device: 'getDevice',
    }),
    ...mapGetters('products', {
      getProductsByCategoryId: 'getAllByCategoryId',
    }),
    ...mapState('products', {
      allBuildProducts: 'all'
    }),
    buildProductByCategory() {
     return this.getProductsByCategoryId(this.productCategory.id);
    },
    selectedProductsAmount() {
      return this.selectedProducts.reduce(
          (accumulator, object) => accumulator + object.amount,
          0,
      );
    },
    buildProductByCategoryAmount() {
      return this.buildProductByCategory.reduce(
          (accumulator, object) => accumulator + object.amount,
          0,
      );
    },
  },
  methods: {
    selectProduct(product) {
      const index = this.selectedProducts.findIndex(selectedProduct => selectedProduct.id === product.id);

      if (index === -1) {
        this.selectedProducts.push(product);
        return;
      }

      if (product.amount === 0) {
        this.selectedProducts.splice(index, 1);
        return;
      }

      this.selectedProducts[index].amount = product.amount;
    },
    productAmount(product) {
      const selectedProduct = this.selectedProducts.find(selectedProduct => selectedProduct.id === product.id);

      return selectedProduct ? selectedProduct.amount : 0;
    },
    editCart() {
      if (this.selectedProductsAmount !== this.buildProductByCategoryAmount) {
        this.$store.dispatch('products/syncProductsByCategoryId', {
          categoryId: this.productCategory.id,
          products: this.selectedProducts,
        });
      }

      this.$emit('close');
    }
  },
  mounted() {
    this.isMounted = true;
  },
  created() {
    this.buildProductByCategory.forEach(buildProduct => {
      this.selectedProducts.push(cloneDeep(buildProduct));
    });

    this.hasInitialSelectedProducts = this.selectedProducts.length > 0;
  }
};
</script>

